import { useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import Webcam from "react-webcam";
import "../App.css";

const videoConstraints = {
    width: { ideal: 720 },
    height: { ideal: 1280 },
    facingMode: "user"
};

const Camera = forwardRef(({ onCapture, paused, intervalSeconds = 2, autoScan = true }, ref) => {
    const webcamRef = useRef(null);

    useImperativeHandle(ref, () => ({
        capture: () => {
            const imageSrc = webcamRef.current?.getScreenshot();
            if (imageSrc) onCapture(imageSrc);
        }
    }));

    useEffect(() => {
        if (paused || !autoScan) return;
        const interval = setInterval(() => {
            const imageSrc = webcamRef.current?.getScreenshot();
            if (imageSrc) onCapture(imageSrc);
        }, intervalSeconds * 1000);
        return () => clearInterval(interval);
    }, [paused, onCapture, intervalSeconds, autoScan]);

    return (
        <div className="camera-container">
            <div className="camera-wrapper camera-wrapper--portrait">
                <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                    className="webcam-view webcam-view--portrait"
                />
                <div className="camera-overlay">
                    <p className="camera-instruction">Mira a la cámara para identificarte</p>
                </div>
            </div>
        </div>
    );
});

export default Camera;
